import React from "react";
import { PhotoHero } from "./PhotoHero";
import { COLORS } from "../theme";

// Foto real: entrega del vehículo al cliente en el concesionario.
export const SEntrega: React.FC = () => (
  <PhotoHero
    src="footage/entrega-concesionario.png"
    kicker="En el concesionario"
    kickerColor={COLORS.greenLight}
    title="La entrega final al cliente"
    origin="55% 50%"
    scanLabel="Registrando entrega…"
    doneLabel="Entrega confirmada"
  />
);
